<div class="p-3">
  <h5>{{(SdSvc.oneEntity$ | async)?.Name}}</h5>
  <p>{{ 'user' | translateWithFallback }}: {{ getTranslateUserIdToName((SdSvc.oneEntity$ | async)?.UserId) }}</p>
  <p>{{ 'owner' | translateWithFallback }}: {{ getTranslateOwnerIdToName((SdSvc.oneEntity$ | async)?.OwnerId) }}</p>
  <p>{{ 'created' | translateWithFallback }}: {{(SdSvc.oneEntity$ | async)?.Created | date:'dd/MM/yyyy hh.mm.ss'}}</p>
  <p>{{ 'modified' | translateWithFallback }}: {{(SdSvc.oneEntity$ | async)?.Modified | date:'dd/MM/yyyy hh.mm.ss'}}</p>
</div>

<!-- <json-editor [options]="editorOptions" [data]="data" (change)="onChangeJson($event)"></json-editor> -->

<div class="row p-3 justify-content-between">
    <div class="col-auto">
        <dx-button class="btn btn-primary" (click)="saveDuplicate()"  [disabled]="!isDataChanged">
          {{ 'save-as-duplicate' | translateWithFallback }}
        </dx-button>
    </div>
</div>
